import React, { useEffect, useState } from "react";
import { FaRegHeart, FaUser, FaBars, FaTimes } from "react-icons/fa";

import {  MdOutlineShoppingCart } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import Accordion from "./Accordion";
import { AnimatePresence, motion } from "framer-motion";

import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import axios from "axios";
import { removeFromCart } from "../../Slices/cart/Cart";
import { logout } from "../../Slices/cart/auth/Auth";

import SearchBar from "./SearchBar";

function HeaderBar() {
  const cart = useSelector(state => state.cart);
  const weburl = useSelector(state => state.constants.weburl);
  const wish = useSelector(state => state.wish);
  const auth = useSelector(state => state.auth);
  //const navigate = useNavigate();
  
  var temp = auth.token;
  if (temp === '') {
    temp = localStorage.getItem('token');
  }
  
  const [loginPop, setLoginPop] = useState(false);
  const [hoverCart, setHoverCart] = useState(false);
  const [categories, setCategories] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  
  const dispatch = useDispatch();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

 

  const handleLoginPop = (e) => {
    e.preventDefault();
    setLoginPop(!loginPop);
  }

  useEffect(() => {
    axios.get('api/tree/categorylist').then(res => {
      setCategories(res.data.categories);
    });
  }, [])

  const handleHoverCart = () => {
    setHoverCart(!hoverCart);
  }

 



  const cartCount = cart.reduce((acc, item) => acc + item.qty, 0);
  const cartTotal = cart.reduce((acc, item) => acc + (item.unitsaleprice * item.qty), 0);

  return (
    <>
      

 
      {/* Main Header */}
      <header className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-yellow-400 shadow-lg' : 'bg-yellow-300 shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* One Line Header - Logo, Search, Icons */}
          <div className="flex items-center justify-between gap-3 py-3">
            
            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors flex-shrink-0"
            >
              {mobileMenuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
            </button>

            {/* Logo */}
            <Link to="/" className="flex-shrink-0">
              <img src="images/logo.png" alt="logo" className="h-14 md:h-16 xl:h-16 lg:h-16 w-auto object-contain" />
            </Link>

            {/* Search Bar - Desktop */}
            <div className="hidden lg:block flex-1 max-w-2xl mx-4">
              <SearchBar />
            </div>

           

            {/* Navigation Icons - Desktop & Mobile */}
            <div className="flex items-center gap-3 md:gap-5 flex-shrink-0">
              
              {/* Wishlist - Visible on both desktop & mobile */}
              <Link to="/wishlist" className="relative group">
                <div className="flex flex-col items-center">
                  <FaRegHeart className="text-gray-600 group-hover:text-red-500 transition-colors text-xl" />
                  <span className="hidden lg:block text-xs text-gray-500 mt-1">Wishlist</span>
                </div>
                {wish.length > 0 && (
                  <span className="absolute -top-2 -right-2 h-5 w-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                    {wish.length}
                  </span>
                )}
              </Link>

              {/* Account - Desktop only */}
              <div className="  relative">
                <button onClick={handleLoginPop} className="flex flex-col items-center">
                  <FaUser className="text-gray-600 hover:text-blue-600 transition-colors text-xl" />
                  <span className="text-xs hidden lg:block text-gray-500 mt-1">Account</span>
                </button>
                
                <AnimatePresence>
                  {loginPop && (
                    <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-2xl border border-gray-100 z-50"
                    >
                      <div className="p-4">
                        {temp ? (
                          <div className="space-y-2">
                            <Link to="/myorders" onClick={() => setLoginPop(false)} className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition">
                              My Orders
                            </Link>
                            <Link to="/profile" onClick={() => setLoginPop(false)} className="block px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-lg transition">
                              Profile Settings
                            </Link>
                            <hr className="my-2" />
                            <button onClick={() => dispatch(logout())} className="w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition">
                              Logout
                            </button>
                          </div>
                        ) : (
                          <div className="space-y-3">
                            <p className="text-sm text-gray-600">Welcome! Please sign in</p>
                            <Link to="/login" onClick={() => setLoginPop(false)} className="block w-full text-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition">
                              Sign In
                            </Link>
                            <Link to="/login" onClick={() => setLoginPop(false)} className="block w-full text-center px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition">
                              Create Account
                            </Link>
                          </div>
                        )}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>

              {/* Cart - Visible on both desktop & mobile */}
              <div className="relative">
                <button onClick={handleHoverCart} className="flex flex-col items-center relative">
                  <MdOutlineShoppingCart className="text-gray-600 hover:text-blue-600 transition-colors text-2xl" />
                  <span className="hidden lg:block text-xs text-gray-500 mt-1">Cart</span>
                  {cartCount > 0 && (
                    <span className="absolute -top-2 -right-2 h-5 w-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
                      {cartCount}
                    </span>
                  )}
                </button>

                <AnimatePresence>
                  {hoverCart && (
                    <motion.div
                      initial={{ opacity: 0, y: -10 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -10 }}
                      className="absolute right-0 mt-2 w-96 bg-white rounded-xl shadow-2xl border border-gray-100 z-50"
                    >
                      <div className="p-4">
                        <div className="flex justify-between items-center mb-4">
                          <h3 className="font-semibold text-gray-800">Shopping Cart ({cartCount} items)</h3>
                          <button onClick={handleHoverCart} className="text-gray-400 hover:text-gray-600">
                            <RxCross2 />
                          </button>
                        </div>
                        
                        <div className="max-h-80 overflow-y-auto space-y-3">
                          {cart.length === 0 ? (
                            <div className="text-center py-8">
                              <MdOutlineShoppingCart className="text-4xl text-gray-300 mx-auto mb-2" />
                              <p className="text-gray-500">Your cart is empty</p>
                              <Link to="/" className="text-blue-600 text-sm mt-2 inline-block">Continue Shopping →</Link>
                            </div>
                          ) : (
                            cart.map((item, index) => (
                              <motion.div
                                key={index}
                                initial={{ opacity: 0, x: 20 }}
                                animate={{ opacity: 1, x: 0 }}
                                className="flex gap-3 p-2 border border-gray-100 rounded-lg"
                              >
                                <img
                                  src={item.image ? `${weburl}/${item.image}` : `${weburl}/images/placeholder.png`}
                                  alt={item.name}
                                  className="w-16 h-16 object-cover rounded-lg"
                                />
                                <div className="flex-1">
                                  <h4 className="text-sm font-medium text-gray-800 line-clamp-1">{item.name}</h4>
                                  <p className="text-xs text-gray-500">Qty: {item.qty}</p>
                                  <p className="text-sm font-semibold text-blue-600">Rs {(item.unitsaleprice * item.qty).toFixed(2)}</p>
                                </div>
                                <button onClick={() => dispatch(removeFromCart(item))} className="text-gray-400 hover:text-red-500">
                                  <RxCross2 />
                                </button>
                              </motion.div>
                            ))
                          )}
                        </div>

                        {cart.length > 0 && (
                          <>
                            <div className="border-t mt-4 pt-4">
                              <div className="flex justify-between mb-4">
                                <span className="text-gray-600">Subtotal:</span>
                                <span className="font-bold text-gray-800">Rs {cartTotal.toFixed(2)}</span>
                              </div>
                              <div className="flex gap-3">
                                <Link to="/viewcart" onClick={() => setHoverCart(false)} className="flex-1 px-4 py-2 border border-gray-300 text-center rounded-lg hover:bg-gray-50 transition">
                                  View Cart
                                </Link>
                                <Link to="/viewcart" onClick={() => setHoverCart(false)} className="flex-1 px-4 py-2 bg-blue-600 text-white text-center rounded-lg hover:bg-blue-700 transition">
                                  Checkout
                                </Link>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>

        {/* Mobile Menu Drawer */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, x: -100 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -100 }}
              className="fixed inset-0 z-50 lg:hidden"
            >
              <div className="absolute inset-0 bg-black/50" onClick={() => setMobileMenuOpen(false)} />
              <div className="absolute left-0 top-0 bottom-0 w-80 bg-white shadow-2xl">
                <div className="p-4 border-b">
                  <div className="flex justify-between items-center">
                    <h2 className="text-lg font-bold">Menu</h2>
                    <button onClick={() => setMobileMenuOpen(false)} className="p-2">
                      <FaTimes />
                    </button>
                  </div>
                </div>
                <div className="p-4 space-y-4">
                  {/* Mobile Account Section */}
                  <div className="border-b pb-4">
                    {temp ? (
                      <div className="space-y-2">
                        <Link to="/myorders" className="flex items-center gap-3 py-2" onClick={() => setMobileMenuOpen(false)}>
                          <FaUser className="text-gray-600" />
                          <span>My Orders</span>
                        </Link>
                        <button onClick={() => dispatch(logout())} className="flex items-center gap-3 py-2 w-full text-left">
                          <FaUser className="text-gray-600" />
                          <span>Logout</span>
                        </button>
                      </div>
                    ) : (
                      <div className="space-y-2">
                        <Link to="/login" className="flex items-center gap-3 py-2" onClick={() => setMobileMenuOpen(false)}>
                          <FaUser className="text-gray-600" />
                          <span>Login / Register</span>
                        </Link>
                      </div>
                    )}
                  </div>
                  
                  <Link to="/wishlist" className="flex items-center gap-3 py-2" onClick={() => setMobileMenuOpen(false)}>
                    <FaRegHeart className="text-gray-600" />
                    <span>Wishlist ({wish.length})</span>
                  </Link>
                  
                  <hr />
                  <Accordion categories={categories} showCategory={() => setMobileMenuOpen(false)} />
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </header>
    </>
  );
}

export default HeaderBar;